import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { Modal, Toast } from '../message';
import Request from '../../util/fetch';
import Input, { Textarea } from '../input';

import './index.less';

/* global ActiveXObject */

/**
 * 判断是否支持Flash
 * 
 * 代码直接移植自 music-web-mainsite/js/web2/api.js/NEJ.P('nm.x')._$supportFlash
 * 
 * @return {Object} 是否支持 flash（supported） 与 flash 版本号（version）
 */
const supportFlash = () => {
    let object,
        hasFlash = !1,
        verFlash = '',
        userAgent = navigator.userAgent;
    // _b._$KERNEL.browser=='ie'
    // 正则表达式来自 nej/src/base/platform/_$KERNEL
    if (/msie\s+(.*?);/i.test(userAgent) || /trident\/.+rv:([\d\.]+)/i.test(userAgent)) {
        try {
            object = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
        } catch (e) {
            object = null;
        }
        if (object) {
            hasFlash = !0;
            verFlash = object.GetVariable("$version");
        }
    } else {
        if (navigator.plugins && navigator.plugins.length > 0) {
            object = navigator.plugins["Shockwave Flash"];
            if (object) {
                hasFlash = !0;
                verFlash = object.description;
            }
        }
    }
    return { supported: hasFlash, version: verFlash };
}

/**
 * 读取本地日志记录
 * 
 * @return {string} 日志文本
 */
const getLocalLog = () => {
    // 日志存放有两种情况，一种是在 NEJ 的缓存里，一种是在 localStorage 里
    // NEJ 的缓存实现在 nej/src/util/cache/cache.js
    // 不确定接下来会不会继续使用 NEJ 或者往 NEJ 的缓存塞东西
    // 所以只实现了从 localStorage 取数据
    const LOCAL_LOG_KEY = 'local-log';
    const data = localStorage.getItem(LOCAL_LOG_KEY) || null;
    return JSON.parse(data);
}

/**
 * 发送私信 Modal 内部的内容
 * 
 * @class FeedbackBox
 * @extends {Component}
 */
class FeedbackBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: '',
            contact: '',
            submitting: false,
            errMsg: null
        }

        this.updateContent = this.updateContent.bind(this);
        this.updateContact = this.updateContact.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.submit = this.submit.bind(this);
    }

    /**
     * 同步发送内容到 state
     * 
     * @param {Event} event - 事件对象
     * @memberof FeedbackBox
     */
    updateContent(content) {
        this.setState({
            content,
            errMsg: null
        });
    }

    /**
     * 同步联系方式到 state
     * 
     * @param {Event} event - 事件对象
     * @memberof FeedbackBox
     */
    updateContact(contact) {
        this.setState({
            contact,
            errMsg: null
        });
    }

    /**
     * 发送反馈方法
     * 
     * @returns {Promise} fetch 请求对象，then 传入是否发送成功
     * @memberof FeedbackBox
     */
    submit() {
        const { content, contact } = this.state;
        const config = {
            url: '/api/feedback/web',
            type: 'json',
            method: 'post',
            noEnc: true
        }
        const xInfo = {
            ua: navigator.userAgent,
            hash: top.location.hash,
            href: location.href,
            flash: supportFlash(),
            contact: contact
        };
        const data = {
            content,
            client: 'web',
            xInfo: JSON.stringify(xInfo)
        };
        const logs = getLocalLog();
        if (logs && logs.length) {
            data.log = logs.join('\n');
        }
        config.data = data;

        return Request.fetch(config).then(res => {
            if (res.code === 200) {
                return true;
            }
            return false;
        }).catch(err => {
            // 错误信息似乎没有价值
            //console.error(err);
            return false;
        });
    }

    /**
     * 请求发送反馈
     * 检查输入是否合法与展示提示信息
     * 
     * @memberof FeedbackBox
     */
    onSubmit(event) {
        event.preventDefault();

        const { content, contact, submitting } = this.state;
        if (submitting) {
            return;
        }

        // 没有输入内容
        if (content.trim().length === 0) {
            this.setState({
                errMsg: '反馈内容不能为空'
            });
            return;
        }
        if (contact.length > 100) {
            this.setState({
                errMsg: '联系方式最多只能输入100个字符'
            });
            return;
        }

        this.setState({
            submitting: true
        }, () => {
            this.submit().then(isSucc => {
                const { onSuccess, onClose } = this.props;

                if (isSucc) {
                    // 关闭 modal，方法由生成时传入组件
                    onClose && onClose();

                    Toast({
                        type: 'success',
                        text: '意见发送成功'
                    }, 3000);

                    // 若指定回调函数，则调用
                    onSuccess && onSuccess(isSucc);
                }
                else {
                    // 请求失败，恢复发送状态
                    Toast({
                        type: 'error',
                        text: '意见发送失败'
                    }, 3000);

                    this.setState({
                        submitting: false
                    });
                }
            })
        });
    }

    render() {
        const { onCancel } = this.props;
        const { content, contact, errMsg, submitting } = this.state;
        return (
            <div>
                <div className="m-fdback">
                    <div className="tip">任何产品中的问题，欢迎反馈给我们</div>
                    <div className="u-txtwrap f-pr">
                        <Textarea className="u-txt area" placeholder="请输入反馈内容" 
                            onChange={ this.updateContent } value={ content } />
                        {/* <span className="zs s-fc2">{ content.length }/140</span> */}
                    </div>
                    <div className="u-txtwrap f-pr holder-parent">
                        <Textarea className="u-txt contact" placeholder="请留下联系方式（电话、QQ、邮箱）" 
                            maxLength="100" onChange={ this.updateContact } value={ contact } />
                    </div>
                    {
                        errMsg && (
                            <div className="u-err">
                                <i className="u-icn u-icn-25"></i>
                                { errMsg }
                            </div>
                        )
                    }
                </div>
                <div className="lybtn f-tc">
                    <a href="javascript:;" onClick={ this.onSubmit } className="btn u-nbtn u-nbtn-blue">
                        <i>{ submitting ? '发送中...' : '发送意见' }</i>
                    </a>
                    <a href="javascript:;" onClick={ onCancel } className="btn u-nbtn u-nbtn-white">
                        <i>取 消</i>
                    </a>
                </div>
            </div>
        );
    }
}

FeedbackBox.propTypes = {
    content: PropTypes.string,
    contact: PropTypes.string,
    onSuccess: PropTypes.func,
    onClose: PropTypes.func
}

/**
 * 发送反馈 Modal 调用方法
 * 
 * @param {object} [config={}] - 配置参数
 * @param {function} [config.content] - 默认发送文本
 * @param {function} [config.contact] - 默认联系方式文本
 * @param {function} [config.onSuccess] - 发送成功回调函数
 * @returns {ReactElement}
 */
const Feedback = (config = {}) => {
    let modal;
    const onClose = () => {
        modal.hide();
    };
    const onCancel = () => {
        modal.close();
    };
    const content = (<FeedbackBox {...config} onClose={ onClose } onCancel={ onCancel }/>);

    modal = Modal({
        title: '意见反馈',
        hideDone: true,
        width: 600,
        /* 按钮样式与回调方式非预设，需要直接在 content 里实现 */
        // doneLabel: '发送意见',
        // cancelLabel: '取 消',
        layerClass: 'm-layer m-layer-feedback',
        lyctClass: 'lyct f-cb',
        content
    });

    return modal;
};

export default Feedback;


// WEBPACK FOOTER //
// ./client/component/feedback/index.js